import { MediaHelpers } from '@wajeez-web/core/api';
import React from 'react';
import {
  BaseComponentProps,
  useComponentData,
} from '@wajeez-web/components/page-view-builder';
import { ClickableComponentLayout } from '@wajeez-web/components/page-view-builder';

export interface DropdownSearchResultItemParameters {
  image: string | null;
}

interface DropdownSearchResultItemProps extends BaseComponentProps {
  onClick?: () => void;
}

export const DropdownSearchResultItem = React.forwardRef<
  HTMLDivElement,
  DropdownSearchResultItemProps
>(({ component, context, isLastSibling, extraProps, onClick }, ref) => {
  const { getParameterValue, content, isLockedContent } =
    useComponentData<DropdownSearchResultItemParameters>(component, context);

  const image = getParameterValue('image');

  return (
    <ClickableComponentLayout content={content} onClickExtra={onClick}>
      <div
        ref={ref}
        className={`w-full py-4 sm:py-0 flex items-start justify-start ${
          !isLastSibling && 'border-b-[0.5px]'
        } border-[#C6C6C8] dark:border-dark-divider sm:border-none`}
      >
        <div
          style={{
            backgroundImage:
              'url(' + MediaHelpers.getPublicMediaById(image) + ')',
          }}
          className={`relative h-[65px] w-[70px] min-w-[70px] border sm:border-none bg-cover bg-center bg-no-repeat rounded-[10px]`}
        >
          {isLockedContent && content?.contentEntityType !== 'FICTION' && (
            <div className="w-[20px] h-[20px] absolute bottom-[5px] left-[5px]">
              <img
                src="../../assets/images/lock.png"
                alt="lock"
                className="block w-full h-full"
              />
            </div>
          )}
        </div>
        <div className="w-full self-stretch sm:pr-[16px] sm:px-0 sm:pt-2 flex flex-col justify-center items-start">
          <div className="text-[15px] font-medium sm:font-bold sm:text-black">
            {content?.title}
          </div>
          <div className="text-[12px] sm:text-[15px] sm:font-medium mt-[3px] text-[rgba(60,_60,_67,_0.6)] sm:text-[#A1A5AC]">
            {content?.authors?.toString().replaceAll(',', ' و ')}
          </div>
          <div
            className="w-fit text-[12px] mt-[3px] px-2 py-1 rounded-[5px]"
            style={{ backgroundColor: extraProps?.['color'] }}
          >
            {extraProps?.['displayName']}
          </div>
        </div>
      </div>
    </ClickableComponentLayout>
  );
});
